import { Button } from "@/components/ui/button";
import { MoveLeft } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const RefundPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-b from-[hsl(var(--gradient-start))] to-[hsl(var(--gradient-end))] pb-24 px-6 pt-[calc(env(safe-area-inset-top,0px)+1.5rem)]">
            {/* Simple public header - no app chrome */}
            <div className="max-w-2xl mx-auto mb-8 flex items-center justify-between">
                <Link to="/site" className="text-xl font-extrabold text-primary font-heading tracking-tight">HomeEzi</Link>
                <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="text-muted-foreground">
                    <MoveLeft className="mr-2 h-4 w-4" />Back
                </Button>
            </div>
            <div className="max-w-2xl mx-auto bg-white/50 backdrop-blur-md rounded-3xl p-8 shadow-xl border border-white/20">
                <Button
                    variant="ghost"
                    className="mb-8 pl-0 hover:bg-transparent"
                    onClick={() => navigate(-1)}
                >
                    <MoveLeft className="mr-2 h-4 w-4" />
                    Back
                </Button>

                <h1 className="text-3xl font-bold mb-6 font-heading text-foreground">Refund Policy</h1>
                <p className="text-sm text-muted-foreground mb-8 italic">Last updated: March 06, 2026</p>

                <div className="space-y-6 text-foreground/80 leading-relaxed font-body">
                    <section>
                        <h2 className="text-xl font-semibold mb-3 text-foreground underline decoration-primary/30">1. Trial and Subscription</h2>
                        <p>We believe in our product, which is why we offer a 7-day free trial on our premium plans. No charges are made until after your free trial expires.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3 text-foreground underline decoration-primary/30">2. Refund Eligibility</h2>
                        <p>Once a subscription is active and has been charged, we typically do not offer refunds as our services are provided digitally and are accessible immediately. However, if there was a technical error or an accidental duplicate charge, we will investigate and provide a full refund within 48 hours of notification.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3 text-foreground underline decoration-primary/30">3. Cancellation</h2>
                        <p>You can cancel your subscription at any time through the Billing section in your Profile. Upon cancellation, you will continue to have access to premium features until the end of your current billing cycle.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3 text-foreground underline decoration-primary/30">4. Processing Time</h2>
                        <p>Approved refunds will be processed via your original payment method (Stripe or Paystack). It may take 5–10 business days for the refund to reflect in your account, depending on your bank.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3 text-foreground underline decoration-primary/30">5. Contact Us</h2>
                        <p>If you have questions about your charges or wish to request a refund, please contact us at support@homeezi.co.za.</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;
